module.exports = __webpack_public_path__ + "static/media/miguel-perales.83d74f3f.jpg";